<template>
  <div class="search-picker" @mouseleave="openState = false"
       @mouseenter="openState = true" >
    <div class="input-placeholder" v-on:click.self="openState=true">
      <div class="input-icon">
        <img src="/static/img/map-marker-check-light.svg" alt="">
      </div>
      <span class="value" v-if="value">{{value}}</span>
      <span class="value" v-else>{{$t('v2.zone.mainZone')}}</span>
    </div>
    <div class="picker-dropdown" :class="{open: openState}">
      <div class="list-item"
           v-for="(zone, index) in zones"
           :index="index"
           :key="zone.id ? zone.id : 'unique'"
           :class="{active: zone.id === currentId}"
           @click="choose(zone.id)"
      >
        <span v-if="zone.name">{{zone.name}}</span>
        <span v-else>{{$t('v2.zone.mainZone')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "search-zone-picker",
  computed: {
    ...mapState({
      zones: s => {
        return [
          {id: null, name: null}
        ].concat(s.search.availableRoomZones);
      },
      currentId: s => s.search.search.zone,
      value: s => {
        const zones = s.search.availableRoomZones;
        const currentZone = s.search.search.zone;
        for (const zone of zones) {
          if (zone.id === currentZone) {
            return zone.name;
          }
        }
        return null;
      }
    })
  },
  data () {
    return {
      openState: false
    }
  },
  methods: {
    choose (id) {
      this.$store.commit('search/SET_SEARCH_ZONE', id);
      this.openState = false;
    }
  }
}
</script>

<style scoped>
  .picker-dropdown:not(.open) {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/picker/search-zone-picker.vue